import React, { useState, useEffect } from 'react';
import { PopupSelect, selectComponents } from '@atlassian/jira-portfolio-3-common';
import PopupSelectButton from '../button';
import type { TriggerProps } from '../types';
import type { Props } from './types';

function BasicPopupSelect({
	label,
	options,
	onChange,
	value,
	defaultIsOpen = false,
	emptyValues = [],
	isDisabled = false,
	minMenuWidth = 220,
	maxMenuWidth = 440,
	maxMenuHeight = 300,
	testId,
}: Props) {
	const [selectValues, setSelectValues] = useState(value);

	useEffect(() => {
		setSelectValues(value);
	}, [value]);

	const renderButton = (isOpen: boolean, triggerProps: TriggerProps) => (
		<PopupSelectButton
			label={label}
			triggerProps={triggerProps}
			selectValues={selectValues}
			isDisabled={isDisabled}
			isMulti={false}
			isSelected={isOpen}
			emptyValues={emptyValues}
			testId={`${testId}-trigger`}
		/>
	);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const renderMenuList = (props: any) => (
		<selectComponents.MenuList {...props}>
			<div data-testId={testId}>{props.children}</div>
		</selectComponents.MenuList>
	);

	return (
		<PopupSelect
			defaultIsOpen={defaultIsOpen}
			isSearchable={false}
			searchThreshold={10000} // need to put large number to make isSearchable=false to work
			options={options}
			minMenuWidth={minMenuWidth}
			maxMenuWidth={maxMenuWidth}
			maxMenuHeight={maxMenuHeight}
			popperProps={{ strategy: 'fixed' }}
			onChange={(e: KeyboardEvent) => {
				setSelectValues(e || null);
				if (onChange) {
					onChange(e);
				}
			}}
			value={selectValues}
			components={{ MenuList: renderMenuList }}
			target={({
				isOpen,
				...triggerProps
			}: TriggerProps & {
				isOpen: boolean;
			}) => renderButton(isOpen, triggerProps)}
		/>
	);
}

export default BasicPopupSelect;
